<section class="pt-5 pb-5 pt-xl-0 other-service position-relative">
  <img [src]='environment1 + "assets/images/Square-T-sky-blue.png"' class="t-image" alt="T">
  <div class="horizontal-line"></div>
  <div class="bottom-vertical-line"></div>
  <div class="container">
      <div class="content-heading mb-4">
          <h1 class="page-sub-title cv-text-dark">Our Other Services</h1>
      </div>
      <div class="carousel-sec" style="margin-left: 100px;">
          <owl-carousel-o [options]="customOptions" >
              <ng-template carouselSlide>
                  <div class="item">
                      <div class="card">
                          <div class="card-bg">
                              <img [src]='environment1 + "assets/images/suraksha.png"' alt="suraksha" class="img-fluid" loading="lazy">
                          </div>
                          <div class="card-body p-0">
                              <div class="content mt-3">
                                  <h5 class="fw-bold">Suraksha (AMC)</h5>
                                  <p class="mb-4">The AMC Service from Tata Motors Limited is known as Suraksha and it ensures that the customer can focus entirely on their core business while leaving work related to vehicle maintenance to the experts at Tata Motors</p>
                                  <a href="https://www.customercare-cv.tatamotors.com/services/suraksha-amc.aspx" class="learn-more" target="_blank" rel="noopener noreferrer">Learn more <span>
                                      <img class="arrow" [src]="environment1 + 'images/new-images/right_Arr.svg'" alt="arrow" loading="lazy">

                                  </span></a>
                              </div>
                          </div>
                      </div>
                  </div>
              </ng-template>
              <ng-template carouselSlide>
                  <div class="item">
                      <div class="card">
                          <div class="card-bg">
                              <img [src]='environment1 + "assets/images/kavach.png"' alt="kavach" class="img-fluid" loading="lazy">
                          </div>
                          <div class="card-body p-0">
                              <div class="content mt-3">
                                  <h5 class="fw-bold">Tata Kavach</h5>
                                  <p class="mb-4">By having a shortest possible uptime of vehicles which come in for accidental repairs at the dealers/Tata authorized service stations, Tata Motors offers a delay based compensation under the Tata Kavach – Quick Accident Repair scheme</p>
                                  <a href="https://www.customercare-cv.tatamotors.com/services/tata-kavach.aspx" class="learn-more" target="_blank" rel="noopener noreferrer">Learn more <span>
                                      <img class="arrow" [src]="environment1 + 'images/new-images/right_Arr.svg'" alt="arrow" loading="lazy">


                                  </span></a>
                              </div>
                          </div>
                      </div>
                  </div>
              </ng-template>
              <ng-template carouselSlide>
                  <div class="item">
                      <div class="card">
                          <div class="card-bg">
                              <img [src]='environment1 + "assets/images/e-dukaan.png"' alt="e-dukaan" class="img-fluid" loading="lazy">
                          </div>
                          <div class="card-body p-0">
                              <div class="content mt-3">
                                  <h5 class="fw-bold">e-Dukaan</h5>
                                  <p class="mb-4">Enabling the entire catalogue management process to be less error prone and highly efficient, Online Spare electronic Parts Catalogue Software has tremendously improved the Dealer Communications resulting in fewer spare parts shortages at the showroom level.</p>
                                  <a href="https://edukaan.home.tatamotors/#/" class="learn-more" target="_blank" rel="noopener noreferrer">Learn more <span>
                                      <img class="arrow" [src]="environment1 + 'images/new-images/right_Arr.svg'" alt="arrow" loading="lazy">


                                  </span></a>
                              </div>
                          </div>
                      </div>
                  </div>
              </ng-template>
              <ng-template carouselSlide>
                  <div class="item">
                      <div class="card">
                          <div class="card-bg">
                              <img [src]='environment1 + "assets/images/tata-motors-finance.png"' alt="tata-motors-finance" class="img-fluid" loading="lazy">
                          </div>
                          <div class="card-body p-0">
                              <div class="content mt-3">
                                  <h5 class="fw-bold">Tata Motors Finance Limited</h5>
                                  <p class="mb-4">Tata Motors Finance Limited (TMFL) is the leading and most preferred financial Institution engaged in financing entire range of Tata Motors Commercial and Passenger vehicles. It is a non-deposit taking systemically important (ND-SI) NBFC</p>
                                  <a href="https://www.tmf.co.in/" class="learn-more" target="_blank" rel="noopener noreferrer">Learn more <span>
                                      <img class="arrow" [src]="environment1 + 'images/new-images/right_Arr.svg'" alt="arrow" loading="lazy">


                                  </span></a>
                              </div>
                          </div>
                      </div>
                  </div>
              </ng-template>
              <ng-template carouselSlide>
                  <div class="item">
                      <div class="card">
                          <div class="card-bg">
                              <img [src]='environment1 + "assets/images/tata-care.png"' alt="tata-care" class="img-fluid" loading="lazy">
                          </div>
                          <div class="card-body p-0">
                              <div class="content mt-3">
                                  <h5 class="fw-bold">Tata Motors Care</h5>
                                  <p class="mb-4">Customer Support division of Tata Motors Commercial Vehicles has the widest and vastest service network in India across all commercial vehicle manufacturers. Manages customer engagement through the widespread network of over 1600 authorised service touch points.</p>
                                  <a href="https://www.customercare-cv.tatamotors.com/" class="learn-more" target="_blank" rel="noopener noreferrer">Learn more <span>
                                      <img class="arrow" [src]="environment1 + 'images/new-images/right_Arr.svg'" alt="arrow" loading="lazy">


                                  </span></a>
                              </div>
                          </div>
                      </div>
                  </div>
              </ng-template>
              <ng-template carouselSlide>
                  <div class="item">
                      <div class="card">
                          <div class="card-bg">
                              <img [src]='environment1 + "assets/images/tata-genuine-parts.png"' alt="tata-genuine-parts" class="img-fluid" loading="lazy">
                          </div>
                          <div class="card-body p-0">
                              <div class="content mt-3">
                                  <h5 class="fw-bold">Tata Genuine Parts</h5>
                                  <p class="mb-4">Tata Genuine Parts is a full-range commercial vehicles parts brand that offers long life and reliable performance to single truck owners and fleet owners of TATA vehicles as its parts are made of superior quality material and conform to OE specifications.</p>
                                  <a href="https://www.customercare-cv.tatamotors.com/tata-genuine-parts/tgp-overview.aspx" class="learn-more" target="_blank" rel="noopener noreferrer">Learn more <span>
                                      <img class="arrow" [src]="environment1 + 'images/new-images/right_Arr.svg'" alt="arrow" loading="lazy">


                                  </span></a>
                              </div>
                          </div>
                      </div>
                  </div>
              </ng-template>
            </owl-carousel-o>
      </div>
  </div>
</section>
